import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { isEqual } from 'lodash';
import withErrorValidateByFly from './withErrorValidateByFly';

import CommonDialog from '../Shared/CommonDialog';
import changeConditionForm from './changeConditionForm';

const withTypeAdd = validate => WrappedComponent => {
    class WithTypeAdd extends React.Component {
        constructor(props) {
            super(props);

            this.state = {
                data: {
                    ...props.data
                },
                disableSave: true,
                errors: {}
            };
        }

        static validate(data) {
            return validate(data);
        }

        componentDidUpdate = (prevProps, prevState) => {
            if (!isEqual(prevState.data, this.state.data)) {
                this.props.changeStatusButton(false);
            } else if (prevProps.isLoading !== this.props.isLoading) {
                this.props.changeStatusButton(this.props.isLoading);
            }
        }

        setDisableSave = value => {
            this.state.disableSave && this.setState({ disableSave: value });
        };

        checkData = data =>
            Object.keys(data).reduce((obj, key) => {
                obj[key] = typeof data[key] === 'string' ? data[key].trim() : data[key];
                return obj;
            }, {});

        handleChange = e => {
            const { name, value, type, checked } = e.target;
            const valueEvent = type === 'checkbox' ? checked : value;
            this.setDisableSave(false);
            const data = { ...this.state.data, [name]: valueEvent };
            this.setState(state => ({
                ...state,
                data: {
                    ...state.data,
                    [name]: valueEvent
                },
                errors: this.props.updateErrorsState(name, valueEvent, data, this.state.errors)
            }));
        };

        handleSubmit = e => {
            e.preventDefault();

            const data = this.checkData(this.state.data);
            const errors = WithTypeAdd.validate(data);
            this.setState({ errors, data });

            if (Object.keys(errors).length === 0) {
                this.props.clickSave(data);
            }
        };

        render() {
            const { open, title, clickClose, blockSaveButton, t } = this.props;
            const { data, errors, disableSave } = this.state;
            const actions = [
                {
                    translateId: 'cancel',
                    type: 'cancel'
                },
                {
                    translateId: 'save',
                    type: 'submit',
                    form: 'form',
                    disabled: disableSave,
                    variant: 'contained',
                }
            ];

            return (
                <CommonDialog
                    onClose={clickClose}
                    open={open}
                    title={title}
                    actions={actions}
                    disableButtonSave={blockSaveButton}
                    t={t}
                >
                    <form
                        id="form"
                        autoComplete="off"
                        onSubmit={this.handleSubmit}
                        noValidate
                    >
                        <WrappedComponent
                            {...this.props}
                            data={data}
                            errors={errors}
                            handleChange={this.handleChange}
                        />
                    </form>
                </CommonDialog>
            );
        }
    }

    WithTypeAdd.propTypes = {
        isLoading: PropTypes.bool,
        data: PropTypes.object,
        open: PropTypes.bool,
        title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
        clickClose: PropTypes.func,
        clickSave: PropTypes.func,
        blockSaveButton: PropTypes.bool,
        changeStatusButton: PropTypes.func,
    };

    return compose(
        withErrorValidateByFly(WithTypeAdd.validate),
        changeConditionForm
    )(WithTypeAdd);
};

export default withTypeAdd;
